/**
 * Home V2 Color Constants
 * 
 * Colors from the home-v2 mockup that are not in the theme system.
 * Reference: thoughts/shared/research/2025-12-04-home-v2-mockup-components.md
 */

  // footerBackground: '#1B2831',      // Dark charcoal (new design)
  // navActive: '#FFFFFF',             // White (active tab on dark bg)
  // navInactive: '#01A7C8',           // Primary blue (inactive tab)
  
  // // Background Gradient
  // gradientTop: '#01A7C8',           // Solid cyan at top (matches header)
  // gradientBottom: '#FFFFFF',        // White at bottom (from mockup)

export const HOME_V2_COLORS = {
  // Header
  headerBackground: '#01A7C8',      // Primary cyan
  
  // Footer
  footerBackground: '#C7EDEF',      // Light cyan/mint
  navActive: '#1B2831',             // Dark charcoal (active state)
  navInactive: '#007CAD',           // Teal (inactive state)
  
  // Background Gradient
  gradientTop: '#01A7C8',           // Solid cyan at top (matches header)
  gradientBottom: '#FFFFFF',        // White at bottom (from mockup)
  
  // Avatar placeholder
  avatarBackground: '#C7EDEF',      // Light cyan (matches footer)
  avatarText: '#1B2831',            // Dark charcoal

  // Filter Bar
  filterBackground: 'rgba(1,167,200,0.3)',  // Soft cyan tint behind the pill
  filterPillBackground: 'rgba(0,0,0,0.3)',  // Semi-transparent overlay used inside the card
  filterText: '#FFFFFF',            // White text/icons on gradient background
  filterBorderRadius: 16,           // Border radius for outer edges (px)

  // Cloud Mascot
  cloudBody: '#FFFFFF',             // White cloud body
  cloudShadow: '#E8E8E8',           // Light gray shadow areas
  cloudFace: '#1B2831',             // Dark charcoal for facial features
  cloudCheeks: '#FF9999',           // Soft pink for cheeks

  // Filter Dialog
  dialogBackground: '#FFFFFF',          // White dialog background
  dialogTitle: '#1B2831',               // Dark blue-gray for title
  dialogSectionHeader: '#1B2831',       // Dark blue-gray, uppercase
  dialogBodyText: '#323B46',            // Dark gray body text
  dialogSecondaryText: '#4D5762',       // Secondary gray text
  dialogCloseButton: '#007CAD',         // Teal close button
  dialogOverlay: 'rgba(0, 0, 0, 0.5)',  // black overlay
  
  // Pill buttons
  pillSelectedBg: '#01A7C8',            // Primary teal background
  pillSelectedText: '#FFFFFF',          // White text when selected
  pillUnselectedBg: '#DBF7F8',          // Light teal background
  pillUnselectedText: '#007CAD',        // Teal text when unselected
} as const;

export type HomeV2ColorKey = keyof typeof HOME_V2_COLORS;
